<!-- Kopregel: scope-snelkoppeling links, eigen extra's van de zoektocht rechts. -->
<div class="hd-chart-match-list__head">
  @if (scopeToggleAvailable()) {
    <hd-chart-match-scope-toggle></hd-chart-match-scope-toggle>
  }
  @if (showNameFilter()) {
    <hd-chart-match-name-filter [value]="nameFilter()" (valueChange)="nameFilter.set($event)"></hd-chart-match-name-filter>
  }
  <span class="hd-chart-match-list__head-extra">
    <ng-content select="[matchListHead]" />
  </span>
</div>

@switch (state().status) {
  @case ('error') {
    <div class="hd-chart-match-list__note hd-chart-match-list__note--error">{{ labels().error }}</div>
  }
  @default {
    @if (showStale()) {
      <!-- Nieuwe zoektocht: de vorige treffers blijven gedimd staan (geen hoogtesprong). -->
      <div class="hd-chart-match-list__loading-overlay" aria-live="polite">
        <span class="hd-chart-match-list__loading-pill">{{ labels().loading }}</span>
      </div>
    } @else if (state().status === 'loading') {
      <div class="hd-chart-match-list__note">{{ labels().loading }}</div>
    } @else if ((state().status === 'loaded' && state().items.length === 0) || noNameMatches()) {
      <div class="hd-chart-match-list__note">{{ labels().empty }}</div>
    }
    <div class="hd-chart-match-list__items" [class.is-stale]="showStale()">
      @for (entry of pagedItems(); track trackEntry(entry)) {
        <button type="button" class="hd-chart-match-list__item"
                [class.hd-chart-match-list__item--highlight]="highlight()(entry)"
                (click)="open.emit(entry.item)">
          <i [class]="iconClass(entry) + ' hd-chart-match-list__item-icon'" aria-hidden="true"></i>
          <span class="hd-chart-match-list__item-name">{{ entry.item.name }}</span>
          @if (metaTemplate(); as meta) {
            <span class="hd-chart-match-list__item-meta">
              <ng-container [ngTemplateOutlet]="meta" [ngTemplateOutletContext]="{ $implicit: entry }"></ng-container>
            </span>
          }
        </button>
      }
    </div>
    @if (showPager()) {
      <!-- Gedeelde pager; de paginakeuze valt over het (dock)paneel heen. -->
      <e-paginator
        class="hd-chart-match-list__pager"
        [totalCount]="filteredItems().length"
        [pageSize]="pageSize()"
        [currentPage]="page()"
        dropdownAppendTo="body"
        (currentPageChange)="page.set($event)"
      ></e-paginator>
    }
  }
}
